import { render, staticRenderFns } from "./checkboxes_input.vue?vue&type=template&id=f3a3949a&scoped=true&"
import script from "./checkboxes_input.vue?vue&type=script&lang=js&"
export * from "./checkboxes_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a3949a",
  null
  
)

export default component.exports
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QOptionGroup,QBtn});
